import { resourceExplorerViewsSelector } from "./resourceExplorerViewsSelector";
import { RootState } from "../../../store";

export const resourceExplorerViewsLoadingSelector = (
  state: RootState,
): boolean | undefined => {
  return resourceExplorerViewsSelector(state)?.isLoading;
};
